/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Geographic scope. Legacy free-form values that do not map onto the enum are returned as `null`.
 */
export type GeographicScope = (typeof GeographicScope)[keyof typeof GeographicScope];

export const GeographicScope = {
  local: "local",
  national: "national",
  international: "international",
} as const;
